const toogler = () => {
  const defaultToggleClass = 'toggled';

  const toggle = (toggler) => {
    const targetSelector = toggler.dataset.toggle;
    const toggleClass = toggler.dataset.toggleClass || defaultToggleClass;
    const targets = document.querySelectorAll(targetSelector);

    for (let i = 0; i < targets.length; i += 1) {
      targets[i].classList.toggle(toggleClass);
    }
  };

  document.body.addEventListener('click', (event) => {
    const { target } = event;
    if (target.dataset.toggle) {
      toggle(target);
    }
  });
};

export default toogler;
